"use client";
import MinusIcon from "@/app/assets/images/svg/minus.svg";
import PlusIcon from "@/app/assets/images/svg/plus.svg";
import React, { FC, PropsWithChildren } from "react";
import styles from "./QuantitySelector.module.scss";
import clsx from "clsx";

type QuantitySelectorProps = {
	quantity: number;
	isDisabled?: boolean;
	minValue?: number;
	maxValue?: number;
	customClass?: string;
	onChange: (num: number) => void;
};

const QuantitySelector: FC<PropsWithChildren<QuantitySelectorProps>> = ({
	quantity,
	minValue = 1,
	maxValue = 9999,
	onChange,
	customClass,
	isDisabled = false,
}) => {
	return (
		<div className={clsx([styles.quantity, customClass])}>
			<button
				className={styles.action}
				type='button'
				disabled={isDisabled || quantity <= minValue}
				onClick={() => onChange(quantity - 1)}
			>
				<MinusIcon />
			</button>
			<input
				className={styles.input}
				type='number'
				disabled={isDisabled}
				value={Number(quantity)}
				onChange={(ev) => onChange(parseInt(ev.target.value) || 0)}
				min={minValue}
				max={maxValue}
				readOnly={isDisabled}
			/>
			<button
				className={styles.action}
				type='button'
				disabled={isDisabled || quantity >= maxValue}
				onClick={() => onChange(quantity + 1)}
			>
				<PlusIcon />
			</button>
		</div>
	);
};

export default QuantitySelector;
